export {MAIN_PAGE} from './mainPage.enum'